<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<cdk-virtual-scroll-viewport #virtualScrollViewport itemSize="0" class="virtualScrollViewport">
	<div *cdkVirtualFor="let line of data" class="line">
		<ng-container [ngSwitch]="line.type">
			<div *ngSwitchCase="lineDisplayType.Text">
				{{ line.data }}
			</div>
			<div *ngSwitchCase="lineDisplayType.Html" [innerHTML]="line.data"></div>
		</ng-container>
	</div>
</cdk-virtual-scroll-viewport>
